import { API_URL } from "utils/constants";

export function buildAssetId(asset) {
	return `${asset.id}--${asset.assetType}`;
}

export function buildAssetUrl(libraryId, assetFileName) {
	return `${API_URL}/crm/v1/asset-manager/${libraryId}/images/instantAssets/${assetFileName}`;
}
